import request from "../base-request";

export interface IEmployeeField {
	_id: string;
	name: string;
	tags: string[];
	type: string;
	options: string[];
	"visible-to": string[];
}

export interface IEmployeeFieldData {
	data_fields: IEmployeeField[];
	errors: string[];
	warnings: string[];
}

export const getEmployeeFields = async () => {
	const [employeeFieldData] = await request<IEmployeeFieldData>(`/api/admin/data-fields/employee`);
	return employeeFieldData;
};
